import { useContext } from "react";
import AutoRefreshContext from "views/components/contexts/AutoRefreshContext";
const useAutoRefresh = () => {
  const autoRefresh = useContext(AutoRefreshContext);
  if (!autoRefresh) {
    throw new Error("useAutoRefresh hook needs to be used inside AutoRefreshContext.Provider");
  }
  return autoRefresh;
};
export default useAutoRefresh;
